import { reactive } from 'vue';

const recomputeTriggers = reactive(new Map<string, string>());

export default recomputeTriggers;
